import React from "react";
import { InfoText } from "../../../../../../../components";
import { keyToTitle } from "../../../../../../../utils";
import { formatWords2 } from "../../../../../../../utils/stringUtils";

const sourceOptions = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
  4: "Career Portal",
  5: "CareerJet",
  6: "Dice",
  7: "Glassdoor",
  8: "Indeed",
  9: "LinkedIn",
  10: "Naukari",
  11: "Neuvoo",
  12: "Post Job Free",
  13: "Snaprecruit",
  14: "Stack Overflow",
  15: "ZipRecruiter",
  16: "Employee Referral",
  17: "Employment Agency",
  18: "Gmail",
  19: "Job Fair",
  20: "Others",
  21: "Outlook",
  22: "Passive Sourcing",
  23: "Resume Inbox"
};

const ProfessionDetails = ({data}) => {
  let professionalDetails = [
    {
      "Experience Years": data?.exp?.year,
      "Experience months": data?.exp?.mon,
      "Job Title": formatWords2(data?.jobTitle),
      Source: sourceOptions[data?.source],
      Availability: data?.available,
    
      "Work Authorization": data?.workAuth || "--",
      Relocate: data?.relocation?.willingness ? "Yes" : "No" || "--",
        Skills: formatWords2(data?.skills?.map(item => item?.name)?.join(', ') || "--"),
    },
  ];
  return (
    <div className="flex-1 rounded-lg m-2 shadow-md overflow-auto p-2 ">
      <h6 className="my-2">Profession Details</h6>
      <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 my-3 ">
        {Object.entries(professionalDetails[0]).map(([key, value]) => {
          return (
            <div className="font-[500]">
              <InfoText
                size="sm"
                key={key}
                title={keyToTitle(key)}
                value={value}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfessionDetails;
